import React from 'react';
import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

import { H3 } from '../../../components/typo/Heading';
import P from '../../../components/typo/P';
import Image, { ImageProps } from '../../../components/Image';

type RowImageTitleTextProps = ImageProps & {
  title: string;
  text: string;
  reverse?: boolean;
};

const Row = styled.div`
  display: flex;
  align-items: center;

  ${(props: { reverse: boolean }) =>
    props.reverse &&
    `
    flex-direction: row-reverse;
  `};

  & > img {
    max-width: 100%;
    width: 50%;
  }

  & > div {
    width: 50%;
  }

  ${media.lessThan('md')`
     flex-direction: column-reverse;
  `};

  ${media.moreThan('lg')`
    & > div {
      margin-left: 10em;
      margin-right: 7em;
    }
  `}

  ${media.moreThan('md')`
    text-align: left;
    
    & > div {
      margin-left: 5em;
    }
    
    ${H3} {
      font-size: 2.5em;
    }
  `};
`;

const RowImageTitleText: React.FC<RowImageTitleTextProps> = ({
  title,
  text,
  src,
  alt,
  srcSet,
  reverse = false,
}) => {
  return (
    <Row reverse={reverse}>
      <Image src={src} alt={alt} srcSet={srcSet} />
      <div>
        <H3>{title}</H3>
        <P bigOnDesktop>{text}</P>
      </div>
    </Row>
  );
};

export default RowImageTitleText;
